module.exports = __webpack_public_path__ + "img/PYBWhiteLogo.3b75d949.png";